<template>
    <div>
        
        <div class="content-header">
            <PageTitleComponent title="Crear simpatizante"></PageTitleComponent>
        </div>
        

        
        <section class="content">
            <div class="container-fluid">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Crear simpatizante</h3>
                        <div class="card-tools">
                        </div>
                    </div>
                    <div class="card-body" v-if="!loading">
                        <div class="row">
                            <div class="col-12">
                                <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                                    <div class="row">
                                        <div class="col-12">
                                            <FormInput label="Nombre" name="nombre" id="nommbre" rules="required" v-model="abonado.nombre" />
                                        </div>
                                        <div class="col-12">
                                            <FormInput label="Apellidos" name="apellidos" id="apellidos" rules="required" v-model="abonado.apellidos" />
                                        </div>
                                        <div class="col-12">
                                            <FormInput label="Dni" name="dni" id="dni" rules="required" v-model="abonado.dni" />
                                        </div>
                                        <div class="col-12">
                                            <FormInput label="Fecha de nacimiento" type="date" name="fecha_nacimiento" id="fecha_nacimiento" rules="required" min="1900-01-01" v-model="abonado.fecha_nacimiento" />
                                        </div>
                                        <div class="col-12">
                                            <FormInput label="Email" type="email" name="email" id="email" rules="required" v-model="abonado.email" />
                                        </div>
                                        <div class="col-12">
                                            <FormInput label="Teléfono" name="telefono" id="telefono" rules="required" v-model="abonado.telefono" />
                                        </div>
                                        <div class="col-12">
                                            <FormInput label="Provincia" name="provincia" id="provincia" rules="required" v-model="abonado.provincia" />
                                        </div>
                                        <div class="col-12">
                                            <FormInput label="Localidad" name="localidad" id="localidad" rules="required" v-model="abonado.localidad" />
                                        </div>
                                        <div class="col-12">
                                            <FormInput label="Domicilio" name="domicilio" id="domicilio" rules="required" v-model="abonado.domicilio" />
                                        </div>
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label for="metodo_pago">Método de pago</label>
                                                <ValidationProvider name="metodo_pago" rules="required" v-slot="{ errors }">
                                                    <multiselect v-model="abonado.metodo_pago" :options="metodos_pago" name="metodo_pago" label="texto" :allowEmpty="false" :showLabels="false" id="metodo_pago"></multiselect>
                                                    <span id="exampleInputEmail1-error" class="error invalid-feedback">{{ errors[0] }}</span>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input" type="checkbox" v-model="abonado.validar" id="customCheckbox4" name="validar">
                                                <label class="custom-control-label" for="customCheckbox4">Crear abonado internacional</label>
                                            </div>
                                        </div>
                                        <div class="col-12 text-right">
                                            <Button type="submit" name="button" :disabled="loading">CREAR</Button>
                                        </div>
                                    </div>
                                </ValidationObserver>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-else>
                        <LoaderComponent></LoaderComponent>
                    </div>
                </div>
            </div>
        </section>
        
    </div>
</template>

<script>
import PageTitleComponent from '@/components/backend/components/PageTitleComponent';
import LoaderComponent from '@/components/preloader/LoaderComponent';

export default {    
    data() {
        return {
            abonado: {},
            loading: false,
            metodos_pago : [
                { valor : 1, texto : 'METÁLICO' },
                { valor : 3, texto : 'DATÁFONO' }
            ]
        }
    },
    methods: {
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.crearAbonado();
            }
        },
        crearAbonado() {
            this.loading = true;

            this.abonado.filters = {};

            this.abonado.metodo_pago = this.abonado.metodo_pago.valor;

            this.$store.dispatch(this.config.getVuexAlias('back.simpatizantes.crear'), this.abonado).then(res => {
                this.$toast.success(res.data.message);
                this.$router.push({ name: 'back.simpatizantes.index' });
            }).finally(() => this.loading = false);
        }
    },
    components: {
        PageTitleComponent, LoaderComponent
    }
}
</script>
